import { Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'

@Injectable({
  providedIn: 'root',
})
export class SnackbarCustomService {
  duracao = 5000

  constructor(private matSnackBar: MatSnackBar) {}

  success(message: any) {
    this.matSnackBar.open(message, 'Fechar', {
      duration: this.duracao,
      horizontalPosition: 'right',
      panelClass: ['success-snackbar'],
    })
  }

  error(error: any) {
    // const errorMessage =
    //   typeof error.error === 'object'
    //     ? error.message
    //     : (error.error ?? error.message)
    let message = 'Ocorreu um ou mais erro.'
    if (typeof error === 'string') {
      message = error
    }
    this.matSnackBar.open(message, 'Fechar', {
      duration: this.duracao,
      horizontalPosition: 'right',
      panelClass: ['error-snackbar'],
    })
  }

  errorRequest(error: any) {
    let message = 'Ocorreu um ou mais erro.'
    const objError = error.error
    if (typeof objError == 'string') {
      message = objError
    } else if (objError.statusCode && objError.message) {
      message = objError.message
    } else if (objError.status && objError.title) {
      message = objError.title
    }
    this.matSnackBar.open(message, 'Fechar', {
      duration: this.duracao,
      horizontalPosition: 'right',
      panelClass: ['error-snackbar'],
    })
  }

  info(message: any) {
    this.matSnackBar.open(message, 'Fechar', {
      duration: this.duracao,
      horizontalPosition: 'right',
      panelClass: ['info-snackbar'],
    })
  }

  warning(message: any) {
    this.matSnackBar.open(message, 'Fechar', {
      duration: this.duracao,
      horizontalPosition: 'right',
      panelClass: ['warming-snackbar'],
    })
  }
}
